export interface AdminWalletHistoryTableHeader {
  title: string;
  key: string;
}

export const AdminWalletHistoryTableHeaders: AdminWalletHistoryTableHeader[] = [
  {
    title: "Создано",
    key: "create",
  },
  {
    title: "USER_ID",
    key: "user_id",
  },
  {
    title: "тип",
    key: "type",
  },
  {
    title: "сумма",
    key: "amount",
  },
  {
    title: "кошелёк",
    key: "wallet",
  },
  {
    title: "статус",
    key: "status",
  },
  {
    title: "инфо",
    key: "info",
  },
];

export const AdminWalletHistoryOptions = [];
